import React from 'react'
import { IconButton } from './IconButton'
import * as fnc from 'helpers/fnc'
import { documentationLinks } from 'app/constants'

interface TooltipLabelProps {
    className?: string,
    children: React.ReactNode,
    tooltip: string,
    documentationLink?: string,
    documentationId?: string,
    htmlFor?: string,
    additionalButtons?: JSX.Element[]
}

export function TooltipLabel({ children, tooltip, documentationLink, documentationId, htmlFor, className, additionalButtons }: TooltipLabelProps) {
    return (
        <div className={`tooltip-label ${className ? className : ''}`}>
            {children && <label htmlFor={htmlFor}>{children}</label>}
            <IconButton icon="fas fa-info-circle" noBg tooltip={tooltip} />
            {documentationLink &&
                <IconButton
                    icon="fas fa-book"
                    noBg
                    onClick={(e) => fnc.attachIframe(e.currentTarget, documentationLink)}
                />
            }
            {documentationId && documentationId in documentationLinks &&
                <IconButton
                    icon="fas fa-book"
                    noBg
                    onClick={(e) => fnc.attachIframe(e.currentTarget, documentationLinks[documentationId])}
                />
            }
            {additionalButtons && additionalButtons.map((button) => button)}
        </div>
    )
}

export default TooltipLabel